import React from 'react';
import { Filters } from '../FilterPanel/Filters';
import { TopContainer } from '../Styles';
import { CloseViewerButton } from './CloseViewerButton';
import { ConnectionState } from './ConnectionState';
import { CopyLogButton } from './CopyLogButton';
import { DeleteLogButton } from './DeleteLogButton';
import { FullScreenButton } from './FullScreenButton';
import { IPAddress } from './IPAddress';
import { MessageCountInfo } from './MessageCountInfo';
import { PayloadInfo } from './PayloadInfo';
import { SettingsButton } from './SettingsButton';

export const MenuBar = ({ largerMonitor = false, showSettings = false }) => {
  return (
    <>
      <CloseViewerButton />
      {largerMonitor && <FullScreenButton />}
      <TopContainer>
        <ConnectionState />
        <SettingsButton />
        {!showSettings && <MessageCountInfo />}
        {!showSettings && <PayloadInfo key={`payload-${new Date()}`} />}
        {showSettings && <DeleteLogButton />}
        {showSettings && largerMonitor && <CopyLogButton />}
        {showSettings && <IPAddress />}
        {largerMonitor && !showSettings && <Filters />}
      </TopContainer>
    </>
  );
};

export default MenuBar;
